<wiz-hgroup #actionContainer height="100%" verticalAlign="center">
  <wiz-image [sourceObservable]="data.iconOrDie" width="24px" height="24px"></wiz-image>
  <wiz-label [wizLabel]="data.trsLabel"></wiz-label>
</wiz-hgroup>
